import React, { useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Protection from "./Protection";
import CashValue from "./CashValue";
import ProtectionImage from "../../Assets/Images/Universal-1-1920@2x.png";
import CashValueImage from "../../Assets/Images/Universal-2-1920@2x.png";
import { useTranslation } from "../../Hooks/useTranslation";

const ProtectionPlusPolicyTabDesktop = () => {
  const translations = useTranslation();
  const sliderRef = useRef(null);
  const [activeTab, setActiveTab] = useState(0);

  const settings = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    adaptiveHeight: true,
    beforeChange: (_, next) => setActiveTab(next),
  };

  const handleTabClick = (index) => {
    setActiveTab(index);
    sliderRef.current?.slickGoTo(index);
  };

  return (
    <section className="section py-[134px] lg:py-[150px] overflow-hidden relative">
      <div className="container">
        <div className="flex flex-col lg:flex-row gap-8 items-center">
          {/* Left column: header + tabs + slider content */}
          <div className="w-full lg:w-2/5 reveal-up">
            <div className="text-sm text-gray-600 mb-1 learnmoreacc hidden lg:block">
              {translations.universeProduct_subtitle}
            </div>
            <h2
              className="lg:text-[2.5rem] lg:leading-[2.8rem] text-[24px] leading-[28px] mb-6 extra-title-heading"
              dangerouslySetInnerHTML={{
                __html: translations.universeProduct_heading,
              }}
            />

            {/* Tabs */}
            <div className="flex gap-2 bg-white rounded-full max-w-[260px] universal-tabs-vs mb-24 lg:mb-32">
              <button
                onClick={() => handleTabClick(0)}
                className={`flex-1 py-2 rounded-full text-sm extra-btn-font ${
                  activeTab === 0 ? "active-button-state" : ""
                }`}
              >
                {translations.universeProtection_tab}
              </button>
              <button
                onClick={() => handleTabClick(1)}
                className={`flex-1 py-2 rounded-full text-sm extra-btn-font ${
                  activeTab === 1 ? "active-button-state" : ""
                }`}
              >
                {translations.universeCashValue_tab}
              </button>
            </div>

            {/* Slider with text content only (icon + list) */}
            <div className="protectionTabs">
              <Slider ref={sliderRef} {...settings}>
                <div>
                  <Protection />
                </div>
                <div>
                  <CashValue />
                </div>
              </Slider>
            </div>
          </div>

          {/* Right column: image (changes per active tab) */}
          <div className="w-full lg:w-3/5 hidden lg:block">
            <img
              src={activeTab === 0 ? ProtectionImage : CashValueImage}
              alt={activeTab === 0 ? "Protection" : "Cash Value"}
              className="w-full lg:!max-w-none lg:w-[140%] [@media(min-width:1920px)]:w-[130%] h-auto object-cover reveal-up"
            />
          </div>
        </div>

        {/* Custom dots — centered with the whole section */}
        <div className="flex justify-center gap-3 mt-12">
          {[0, 1].map((i) => (
            <button
              key={i}
              onClick={() => handleTabClick(i)}
              aria-label={`Slide ${i + 1}`}
              className={`w-3 h-3 rounded-full transition-colors ${
                activeTab === i ? "bg-[#0D4248]" : "bg-gray-400"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProtectionPlusPolicyTabDesktop;
